import Axios from "axios";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:6011/api/v1";

export const logout = async (token: string) => {
  return new Promise(async (resolve, reject) => {
    try {
      const body = {
        authTokenString: token,
      };
      await Axios.post(`${baseURL}/users/auth/logout`, body);
      window.location.href = "/login";
    } catch (error) {
      window.location.href = "/login";
    }
  });
};
